import { render, staticRenderFns } from "./ordenClinicaShow.vue?vue&type=template&id=0d646369"
import script from "./ordenClinicaShow.vue?vue&type=script&lang=js"
export * from "./ordenClinicaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports